require("./gatsby/__redocly__css_stub.js"), exports.onClientEntry = function () {
  window.Prism = window.Prism || {}, Prism.manual = !0;
};